module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"objectName":"custom field","parentName":{"contact":"contacts","company":"companies"},"loadError":"Something went wrong and we couldn\u0027t load the custom field. Please try again.","description":"You can add up to {remaining} custom fields to your {recordType} records. Be sure to select a field type that best matches the data you plan to enter."}}')
  delete Component.options._Ctor
}
